







import { Vue, Component } from "@/shared/vuepack";

@Component
export default class UmbFooterCash extends Vue {
}
